/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Close_TicketInputs */

const en_admin_tickets_close_ticket = /** @type {(inputs: Admin_Tickets_Close_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Ticket`)
};

/**
* | output |
* | --- |
* | "Close Ticket" |
*
* @param {Admin_Tickets_Close_TicketInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_close_ticket = /** @type {((inputs?: Admin_Tickets_Close_TicketInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Close_TicketInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_close_ticket(inputs)
});
export { admin_tickets_close_ticket as "admin.tickets.close_ticket" }